import { observer } from 'mobx-react-lite';
import { DefaultButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { exitSearchTooltip } from 'owa-locstrings/lib/strings/exitsearchtooltip.locstring.json';
import { SearchPlaceholder } from 'owa-locstrings/lib/strings/searchplaceholder.locstring.json';
import * as React from 'react';

const styles = require('./SearchButton.scss');

export interface ISearchButtonProps {
    onClick: (evt?: any) => void;
    searchBoxHasFocus: boolean;
    useNextSearchBoxInteractions: boolean;
}

export default observer(function SearchButton(props: ISearchButtonProps): JSX.Element {
    const { onClick, searchBoxHasFocus, useNextSearchBoxInteractions } = props;

    const searchButtonAttributes = React.useMemo(
        () => getSearchBoxButtonAttributes(searchBoxHasFocus),
        [searchBoxHasFocus]
    );

    if (useNextSearchBoxInteractions) {
        return (
            <DefaultButton
                className={styles.searchBoxButton}
                styles={{ icon: { fontSize: '16px' } }}
                onClick={onClick}
                {...searchButtonAttributes}
            />
        );
    }

    return (
        <IconButton
            className={styles.searchButton}
            iconProps={{
                iconName: ControlIcons.Search,
            }}
            onClick={onClick}
            ariaLabel={loc(SearchPlaceholder)}
        />
    );
});

const getSearchBoxButtonAttributes = (searchBoxHasFocus: boolean) => {
    if (searchBoxHasFocus) {
        return {
            ariaLabel: loc(SearchPlaceholder),
            title: loc(SearchPlaceholder),
            iconProps: {
                iconName: ControlIcons.Forward,
            },
        };
    }

    return {
        ariaLabel: loc(exitSearchTooltip),
        title: loc(exitSearchTooltip),
        iconProps: {
            iconName: ControlIcons.Clear,
        },
    };
};
